import { CustomFieldDefinitionActionAvailability } from '@/api/queries/customField/useGetFieldset';
import { Alert, Button, Fieldset, Sidebar } from '@payaca/ambrosia';

import { FC } from 'react';
import { PathToFieldsetChild } from '../types';
import CreateEditCustomFieldFieldset from './CreateEditCustomFieldFieldset';

export type TNestedFieldEditorSidebarProps = {
  isOpen: boolean;
  onClose: () => void;
  fieldPath: PathToFieldsetChild;
  allCurrentIdentifiers: string[];
  isDestructivelyUpdateable: CustomFieldDefinitionActionAvailability['isDestructivelyUpdateable'];
  optionsInUse?: CustomFieldDefinitionActionAvailability['optionsInUse'];
  isPersisted: boolean;
};

const NestedFieldEditorSidebar: FC<TNestedFieldEditorSidebarProps> = (
  props
) => {
  const {
    isOpen,
    onClose,
    fieldPath,
    allCurrentIdentifiers,
    isDestructivelyUpdateable,
    optionsInUse,
    isPersisted,
  } = props;

  return (
    <Sidebar
      zIndexLevel={2}
      isOpen={isOpen}
      onClose={onClose}
      title="Edit nested field"
    >
      <Sidebar.Body className="p-4">
        <Fieldset>
          {!isDestructivelyUpdateable.result && isPersisted && (
            <Alert colour="yellow" className="mb-4">
              <p>Cannot delete or fully edit this field:</p>
              <ul className="m-0">
                {isDestructivelyUpdateable.reasons.map((r, i) => (
                  <li key={`nested-editor-reason-${i}`}>{r}</li>
                ))}
              </ul>
            </Alert>
          )}
          <CreateEditCustomFieldFieldset
            allCurrentIdentifiers={allCurrentIdentifiers}
            isDestructivelyUpdateable={isDestructivelyUpdateable}
            optionsInUse={optionsInUse}
            isPersisted={isPersisted}
            fieldPath={fieldPath}
          />
        </Fieldset>
      </Sidebar.Body>

      <Sidebar.Footer>
        <Button className="w-full" onClick={onClose}>
          Done
        </Button>
      </Sidebar.Footer>
    </Sidebar>
  );
};

export default NestedFieldEditorSidebar;
